import React from 'react';
import { Container, Row, Col, Card, CardBody, ListGroup, ListGroupItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import doc1 from '../../assets/Policies/1 LAKH CASH AWARD TO CADETS.pdf'
import doc2 from '../../assets/Policies/07.04.2006 Monetary Allowance.pdf'
import doc3 from '../../assets/Policies/28.05.2014, Enhancement of Moetary allowanceand Pension.pdf'
import doc4 from '../../assets/Policies/1991 07 30 Grant of Cash award monetary grant and annuity.pdf'
import doc5 from '../../assets/Policies/1992.07.01 Instruction on Ex Gratia.pdf'
import doc6 from '../../assets/Policies/2001.06.15 Reward Money Ex Gratia.pdf'
import doc7 from '../../assets/Policies/2006 03 28 Monetary grant in lieu of land.pdf'
import doc8 from '../../assets/Policies/2007 07 19  Cash award  Annuity.pdf'
import doc9 from '../../assets/Policies/2014 05 28 Enhancement in rate onetime Cash.pdf'
import doc10 from '../../assets/Policies/2015 01 22 Sena medal distinguished.pdf'
import doc11 from '../../assets/Policies/2015 12 09 One time cash award.pdf'
import doc12 from '../../assets/Policies/2016.08.02 Ex Gratia.pdf'
import doc13 from '../../assets/Policies/2016.08.02, Payment of ex-gratia grant.pdf'
import doc14 from '../../assets/Policies/2017.03.06 CMPF Ex Gratia.pdf'
import doc15 from '../../assets/Policies/2017.12.04 , Mode of payment of ex-gratia.pdf'
import doc16 from '../../assets/Policies/2019 12 18 one time cash award to sena medal.pdf'
import doc17 from '../../assets/Policies/Defence Policy letters.pdf'
import doc18 from '../../assets/Policies/EX-GRATIA GRANT.pdf'
import doc19 from '../../assets/Policies/EX-SERVICEMAN RESRVATION.pdf'
import doc20 from '../../assets/Policies/FREE TRAVEL BUS PASS.pdf'
import doc21 from '../../assets/Policies/NOTIFICATION FOR EX-GRATIA GRANT TO DEFENCE AND CAPF PERSONNEL.pdf'
import doc22 from '../../assets/Administrative Reforms.pdf'
import doc23 from '../../assets/RIMC Entrance Exam Schedule.pdf'
const data = [

  { title: 'Office Order dated 27.04.2026', link:doc22},
  { title: 'RIMC Entrance Exam Schedule (Jan 2027 Term)', link:doc23},
  { title: '1 LAKH CASH AWARD TO CADETS', link:doc1},
  { title: '07.04.2006 Monetary Allowance', link:doc2},
  { title: '28.05.2014 Enhancement of Moetary allowance and Pension', link:doc3},
  { title: '1991 07 30 Grant of Cash award monetary grant and annuity', link:doc4},
  { title: '1992.07.01 Instruction on Ex Gratia', link:doc5},
  { title: '2001.06.15 Reward Money Ex Gratia', link:doc6},
  { title: '2006 03 28 Monetary grant in lieu of land', link:doc7},
  { title: '2007 07 19  Cash award  Annuity', link:doc8},
  { title: '2014 05 28 Enhancement in rate onetime Cash', link:doc9},
  { title: '2015 01 22 Sena medal distinguished', link:doc10},
  { title: '2015 12 09 One time cash award', link:doc11},
  { title: '2016.08.02 Ex Gratia', link:doc12},
  { title: '2016.08.02 Payment of ex-gratia grant', link:doc13},
  { title: '2017.03.06 CMPF Ex Gratia', link:doc14},
  { title: '2017.12.04 Mode of payment of ex-gratia', link:doc15},
  { title: '2019 12 18 one time cash award to sena medal', link:doc16},
  { title: 'Defence Policy letters', link:doc17},
  { title: 'EX-GRATIA GRANT', link:doc18},
  { title: 'EX-SERVICEMAN RESRVATION', link:doc19},
  { title: 'FREE TRAVEL BUS PASS', link:doc20},
  { title: 'NOTIFICATION FOR EX-GRATIA GRANT TO DEFENCE AND CAPF PERSONNEL', link:doc21},
 
];
const NotificationOrder = () => {
  return (
    <>
      <div style={{
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '30px 0',
        color: 'white',
        margin: '2%',
        borderRadius: '10px'
      }}>
        <Container>
          <h3 className="fw-bold mb-0 text-center">
            <FontAwesomeIcon icon={faBell} className="me-2" />
            Notifications & Orders
          </h3>
        </Container>
      </div>

      <Container className="py-5">
        <Row>
          <Col lg={12}>
            <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
              <div style={{
                background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                padding: '25px',
                color: 'white'
              }}>
                <h4 className="fw-bold mb-0">
                  <FontAwesomeIcon icon={faBell} className="me-2" />
                  Department Notifications & Orders
                </h4>
              </div>
              <CardBody className="p-4">
                <ListGroup flush>
                  {data.map((rule, index) => (
                    <ListGroupItem 
                      key={index} 
                      className="py-3 px-0 border-bottom"
                      style={{ borderColor: '#e9ecef' }}
                    >
                      <a 
                        href={rule.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}
                      >
                        <div style={{
                          background: 'rgba(30,60,114,0.1)',
                          color: '#1e3c72',
                          padding: '10px 15px',
                          borderRadius: '8px',
                          marginRight: '15px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          minWidth: '30px',
                          fontWeight: '600'
                        }}>
                          {index + 1}
                        </div>
                        <div className="flex-grow-1">
                          <strong style={{ color: '#16a085', fontSize: '1rem' }}>{rule.title}</strong>
                        </div>
                        <div style={{
                          background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                          color: 'white',
                          padding: '8px 20px',
                          borderRadius: '20px',
                          fontSize: '0.85rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          <FontAwesomeIcon icon={faDownload} />
                          View
                        </div>
                      </a>
                    </ListGroupItem>
                  ))}
                </ListGroup>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NotificationOrder;
